import { render } from "./Index.vue?vue&type=template&id=01defa2c"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script